<template>
    <section>
        <div class="my-4">
            <swiper
                v-bind="swiperOptions"
                class="mySwiper"
            >
                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'solitaire-engagement-rings' } })">
                            <picture>
                            <source width="200" height="200" type="image/webp" srcset="~/assets/styles/solitaire.webp">
                            <img loading="lazy"  width="200" height="200" type="image/jpeg" src="~/assets/styles/solitaire.jpg" alt="Solitaire Engagement Rings">
                            </picture>
                            <span>solitaire</span>
                        </NuxtLink>
                    </div>
                </swiper-slide>

                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'side-stone-engagement-rings' } })">
                            <picture>
                            <source width="200" height="200" type="image/webp" srcset="~/assets/styles/sidestone.webp">
                            <img loading="lazy"  width="200" height="200" type="image/jpeg" src="~/assets/styles/sidestone.jpg" alt="Side Stone Engagement Rings">
                            </picture>
                            <span>side stone</span>
                        </NuxtLink>
                    </div>
                </swiper-slide>

                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'three-stone-engagement-rings' } })">
                            <picture>
                              <source width="200" height="200" type="image/webp" srcset="~/assets/styles/threestone.webp">
                              <img loading="lazy"  width="200" height="200" src="~/assets/styles/threestone.jpg" alt="Three Stone Engagement Rings">
                            </picture>
                            <span>three stone</span>
                          </NuxtLink>                          
                    </div>
                </swiper-slide>

                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'vintage-engagement-rings' } })">
                            <picture>
                            <source width="200" height="200" type="image/webp" srcset="~/assets/styles/vintage.webp">
                            <img loading="lazy"  width="200" height="200" type="image/jpeg" src="~/assets/styles/vintage.jpg" alt="Vintage Engagement Rings">
                            </picture>
                            <span>vintage</span>
                        </NuxtLink>
                    </div>
                </swiper-slide>

                <swiper-slide>
                    <div class="slide_box">
                        <NuxtLink :to="localePath({ name:'cyo-setting-list-ring', params:{ start_with: 'halo-engagement-rings' } })">
                            <picture>
                            <source width="200" height="200" type="image/webp" srcset="~/assets/styles/halo.webp">
                            <img loading="lazy" class="img-fluid " width="200" height="200" type="image/jpeg" src="~/assets/styles/halo.jpg" alt="Halo Engagement Rings">
                            </picture>
                            <span>halo</span>
                        </NuxtLink>
                    </div>
                </swiper-slide>
            </swiper>
        </div>
    </section>
</template>

<script setup>
  const localePath = useLocalePath()

  const swiperOptions = {
        // loop:true,
        spaceBetween: 20,
        modules: [SwiperAutoplay],
        centerInsufficientSlides: true,
        autoplay: {
            delay: 2500,
            disableOnInteraction: false,
        },
        breakpoints: {
            0: {
                slidesPerView: 2,
                centeredSlides:true,
                spaceBetween:0,
            },
            512: {
                slidesPerView: 2.2,
            },

            768: {
                slidesPerView: 2.5,
            },

            992: {
                slidesPerView: 5,
                spaceBetween: 40
            },
        },
    };
</script>
  

<style scoped>

.slide_box {
    padding: 0 2%;
    text-align: center;
}
button{
    background: #2a4437;
    color: #fff;
    border-color: #2a4437;
}

h4{
    font-size: 30px;
    font-family: "NY600";
}
p{
    font-weight: 500;
    color: #6a6161;
}
.slide_box span {
    display: block;
    text-align: center;
    color: #000;
    text-transform: uppercase;
    font-size: 14px;
    margin-top: 15px;
    font-weight: 600;
}
@media(max-width: 992px){
    p br{
        display: none;
    }
  
}
@media(max-width: 767px){
    .test_block {
        margin: 7% 0;
    }
    h4{
        font-size: 24px;
    }
}
</style>